import { Box, Grid } from '@factorialco/deprecated-design-system'
import { Currency } from 'dinero.js'
import {
  ItManagementDashboardSoftwareCost,
  ItManagementSoftwareInfoSoftwareSetupFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { monthlyDashboardCosts } from 'modules/it_management/lib/costs'

import Header from './_Header'
import LineChart from './_LineChart'

interface Props {
  softwareSetups: ItManagementSoftwareInfoSoftwareSetupFragment[]
  dashboardCosts: ItManagementDashboardSoftwareCost[]
  currency: Currency
}

const SoftwareDashboard = ({ softwareSetups, dashboardCosts, currency }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()
  const monthlyCosts = monthlyDashboardCosts(dashboardCosts)

  const appCostData = monthlyCosts.map((cost) => ({
    x: cost.month,
    y: cost.appCost,
  }))
  const seatCostData = monthlyCosts.map((cost) => ({
    x: cost.month,
    y: cost.seatCost,
  }))
  const yearToDate = dashboardCosts.reduce((acc, cost) => acc + cost.monthlyCostInCents, 0)
  const yearToDateValue = MoneyWithCurrency({ amount: yearToDate, currency, locale })

  const totalSeatCost = dashboardCosts.reduce((acc, cost) => acc + cost.seatCostInCents, 0)
  const averageSeatCost =
    dashboardCosts.length > 0 ? Math.floor(totalSeatCost / dashboardCosts.length) : 0
  const averageSeatCostValue = MoneyWithCurrency({ amount: averageSeatCost, currency, locale })

  return (
    <Box gap="s24">
      <Header softwareSetups={softwareSetups} dashboardCosts={dashboardCosts} currency={currency} />
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 12, m: 6 }}>
          <LineChart
            data={appCostData}
            title={i18n.t('it_management.software_setups.dashboard.charts.cost_per_month.title')}
            subtitle={i18n.t(
              'it_management.software_setups.dashboard.charts.cost_per_month.subtitle'
            )}
            serieId={i18n.t(
              'it_management.software_setups.dashboard.charts.cost_per_month.tooltip'
            )}
            currentValue={yearToDateValue}
            currency={currency}
          />
        </Box>
        <Box gridColSpan={{ xxs: 12, m: 6 }}>
          <LineChart
            data={seatCostData}
            title={i18n.t('it_management.software_setups.dashboard.charts.cost_per_seat.title')}
            subtitle={i18n.t(
              'it_management.software_setups.dashboard.charts.cost_per_seat.subtitle'
            )}
            serieId={i18n.t('it_management.software_setups.dashboard.charts.cost_per_seat.tooltip')}
            currentValue={averageSeatCostValue}
            currency={currency}
          />
        </Box>
      </Grid>
    </Box>
  )
}

export default SoftwareDashboard
